import {
  formatPrice,
  formatPercentage,
} from "@/modules/BDK_Calculator/lib/formatFunctions";
import HTML from "@/modules/HTML/HTML";

const FinanceInfoText = ({ financingdata, showNettoPreis }) => {
  const { response, request } = financingdata;
  const {
    monthlyInstallmentTotalAmount,
    totalRepaymentAmount,
    balloon,
    netLoanAmount,
  } = response;
  const { effectiveInterestRate, term, deposit } = request;
  const string = `
  <table>
    <tr>
      <td>Anzahlung:</td>
      <td>${formatPrice(deposit) || "k.A"}</td>
    </tr>
    <tr>
      <td>Nettodarlehensbetrag:</td>
      <td>${formatPrice(netLoanAmount || 0)}</td>
    </tr>
    <tr>
      <td>Laufzeit:</td>
      <td>${term || "k.A"} Monate</td>
    </tr>
    <tr>
      <td>Effektiver Jahreszins:</td>
      <td>${formatPercentage(effectiveInterestRate)}</td>
    </tr>
    <tr>
      <td>Schlussrate:</td>
      <td>${
        showNettoPreis
          ? formatPrice(balloon.netValue)
          : formatPrice(balloon.grossValue) || "k.A."
      }</td>
    </tr>
    
    <!-- Add the dividing line here -->
    <tr>
      <td colspan="2" class="py-4 text-gray-300 h-2"><hr /></td>
    </tr>
    
    <tr>
      <td>Gesamtbetrag:</td>
      <td>${
        showNettoPreis
          ? formatPrice(totalRepaymentAmount.netValue)
          : formatPrice(totalRepaymentAmount.grossValue) || "k.A."
      }</td>
    </tr>
    <tr>
      <td>Monatliche Rate ${
        showNettoPreis ? '<span class="text-xs">(zzgl. MwSt.)</span>' : ""
      }:</td>
      <td>${
        showNettoPreis
          ? formatPrice(monthlyInstallmentTotalAmount.netValue)
          : formatPrice(monthlyInstallmentTotalAmount.grossValue) || "k.A"
      }</td>
    </tr>
    <tr>
      <td colspan="2" class="text-[10px] italic leading-[14px] text-blue-dark text-wrap ">
        <br />
        Dies ist eine unverbindliche beispielhafte Finanzierungskalkulation der Bank Deutsches Kraftfahrzeuggewerbe GmbH, Fuhlsbütteler Str. 437, 22309 Hamburg.
        Hierbei handelt es sich gleichzeitig um das repräsentative Beispiel gem. §17 Abs. 4 PAngV. Bonität vorausgesetzt.
      </td>
    </tr>
  </table>
`;
  return (
    <div>
      <HTML content={string} />
    </div>
  );
};

export default FinanceInfoText;
